import { Link, Typography } from '@mui/material'
import React from 'react'

import { TeamExternalIntegration } from 'types/api/services/golden-signal'
import { IntegrationType } from 'utils/team-external-integrations/team-external-integration-types'

export const URLHelperText: React.FC<{
  integration?: TeamExternalIntegration
}> = ({ integration }) => {
  switch (integration?.type) {
    case IntegrationType.Datadog:
    case IntegrationType.DatadogEU:
      return (
        <Typography
          component="span"
          data-testid="url-helper-text-datadog"
          fontSize="smaller"
        >
          Look for help in{' '}
          <Link
            href="https://docs.datadoghq.com/api/latest/monitors/#get-a-monitors-details"
            target="_blank"
          >
            Datadog’s documentation
          </Link>
          . Looking to work with Datadog’s API? Try making a custom status
          check!
        </Typography>
      )
    case IntegrationType.Pagerduty:
      return (
        <Typography
          component="span"
          data-testid="url-helper-text-pagerduty"
          fontSize="smaller"
        >
          Look for help in PagerDuty’s{' '}
          <Link
            href="https://developer.pagerduty.com/api-reference/b3A6Mjc0ODEzOA-list-incidents"
            target="_blank"
          >
            Incident
          </Link>{' '}
          and Service ID documentation
        </Typography>
      )
    case IntegrationType.Newrelic:
      return (
        <Typography
          component="span"
          data-testid="url-helper-text-newrelic"
          fontSize="smaller"
        >
          Look for help in New Relic’s{' '}
          <Link
            href="https://docs.newrelic.com/docs/apis/rest-api-v2/application-examples-v2/application-reporting-health-status-v2/"
            target="_blank"
          >
            Application
          </Link>{' '}
          and Alerts documentation
        </Typography>
      )
    case IntegrationType.Grafana:
      return (
        <Typography
          component="span"
          data-testid="url-helper-text-grafana"
          fontSize="smaller"
        >
          Look for help in Grafana’s{' '}
          <Link
            href="https://grafana.com/docs/grafana/latest/alerting/"
            target="_blank"
          >
            Application and Alerts
          </Link>{' '}
          documentation
        </Typography>
      )
    case IntegrationType.Dynatrace:
      return (
        <Typography
          component="span"
          data-testid="url-helper-text-dynatrace"
          fontSize="smaller"
        >
          Look for help in Dynatrace’s{' '}
          <Link
            href="https://www.dynatrace.com/support/help/how-to-use-dynatrace/synthetic-monitoring"
            target="_blank"
          >
            Synthetic monitoring
          </Link>{' '}
          documentation
        </Typography>
      )
    case IntegrationType.Appdynamics:
      return (
        <Typography
          component="span"
          data-testid="url-helper-text-appdynamics"
          fontSize="smaller"
        >
          Look for help in AppDynamics{' '}
          <Link
            href="https://docs.appdynamics.com/appd/4.5.x/en/appdynamics-essentials/alert-and-respond"
            target="_blank"
          >
            Alert and Respond
          </Link>{' '}
          documentation
        </Typography>
      )
    default:
      return null
  }
}
